import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import queryString from 'query-string';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
import database from '@app/services/database';
import ProjectElementsView from './ProjectElementsView';

import { CompileTOVS } from "@app/utils/CompileTOVS";
import { saveAs } from "file-saver";
import { Packer } from "docx";
import { DocumentCreator } from "@app/utils/DocumentCreator";

class ConnectedProjectElementsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            locale: this.props.locale ? this.props.locale : 'en',
            pageLoad: '',
            // Project Elements
            itConsultation: '',
            projectManagement: '',
            newECommerceSite: '',
            upgradeECommerceSite: '',
            onlinePayments: '',
            bookingSystem: '',
            cms: '',
            app: '',
            digitalMarketingDev: '',
            digitalMarketingImp: '',
            subscriptionLowCostRetail: '',
            onlineAds: '',
            proPhoto: '',
            training: '',
            copy: '',
            seo: '',
            analytics: '',
            other: '',    
            emailAddress: '',  
            emailConsent: false,
            isEmailAddressValid: false,  
            webAddress: '',
            validationErrors: {
                // Project Elements
                itConsultation: { show: false, check: null,  errorMessage: ''  },
                projectManagement: { show: false, check: null,  errorMessage: ''  },
                newECommerceSite: { show: false, check: null,  errorMessage: ''  },
                upgradeECommerceSite: { show: false, check: null,  errorMessage: ''  },
                cms: { show: false, check: null,  errorMessage: ''  },
                onlinePayments: { show: false, check: null,  errorMessage: ''  },
                bookingSystem: { show: false, check: null,  errorMessage: ''  },
                app: { show: false, check: null,  errorMessage: ''  },
                digitalMarketingDev: { show: false, check: null,  errorMessage: ''  },
                digitalMarketingImp: { show: false, check: null,  errorMessage: ''  },
                subscriptionLowCostRetail: { show: false, check: null,  errorMessage: ''  },
                onlineAds: { show: false, check: null,  errorMessage: ''  },
                proPhoto: { show: false, check: null,  errorMessage: ''  },
                training: { show: false, check: null,  errorMessage: ''  },
                copy: { show: false, check: null,  errorMessage: ''  },
                seo: { show: false, check: null,  errorMessage: ''  },
                analytics: { show: false, check: null,  errorMessage: ''  },
                other: { show: false, check: null,  errorMessage: ''  },
                emailAddress: { show: false, check: null, errorMessage: ''  },
                emailConsent: { show: false, check: null, errorMessage: ''  },
                webAddress: { show: false, check: null, errorMessage: ''  }
            },
            isLoading: false,
            errorMessage: '',
            successMessage: '',
            loadToSubmitTime: '',
            shareMessage: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onWebsiteChange = this.onWebsiteChange.bind(this);
        // Project Elements
        this.handleITConsultation = this.handleITConsultation.bind(this);
        this.handleProjectManagement = this.handleProjectManagement.bind(this);
        this.handleNewECommerceSite = this.handleNewECommerceSite.bind(this);
        this.handleUpgradeECommerceSite = this.handleUpgradeECommerceSite.bind(this);
        this.handleCms = this.handleCms.bind(this);
        this.handleOnlinePayments = this.handleOnlinePayments.bind(this);
        this.handleBookingSystem = this.handleBookingSystem.bind(this);
        this.handleApp = this.handleApp.bind(this);
        this.handleDigitalMarketingDev = this.handleDigitalMarketingDev.bind(this);
        this.handleDigitalMarketingImp = this.handleDigitalMarketingImp.bind(this);
        this.handleSubscriptionLowCostRetail = this.handleSubscriptionLowCostRetail.bind(this);
        this.handleOnlineAds = this.handleOnlineAds.bind(this);
        this.handleProPhoto = this.handleProPhoto.bind(this);
        this.handleTraining = this.handleTraining.bind(this);
        this.handleCopy = this.handleCopy.bind(this);
        this.handleSeo = this.handleSeo.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleOther = this.handleOther.bind(this);
        this.generateDoc = this.generateDoc.bind(this);
        this.generateQuote = this.generateQuote.bind(this);
    }

    componentDidMount() {
        if (this.state.pageLoad === '') {
            this.setState({
                pageLoad: new Date().valueOf(),
                emailAddress: localStorage.getItem('tovsForm.about.emailAddress') ? localStorage.getItem('tovsForm.about.emailAddress') : '',
                webAddress: localStorage.getItem('tovsForm.about.webAddress') ? localStorage.getItem('tovsForm.about.webAddress') : ''
            });
        }
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).startsWith('tovsForm.elements.')) {
                this.setState({
                    [localStorage.key(i).substring(18)]: localStorage.getItem(localStorage.key(i))
                });
            }
        }
    }

    handleChange(e) {
        this.setState({ 
            [e.target.value]: e.target.checked
        });
    }

    onEmailChange(e, ref) {
        let value = ref && ref.newValue ? ref.newValue : e.target.value;
        let validationErrors = this.state.validationErrors;
        let isEmailAddressValid = value.trim().match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i) !== null;
        if (isEmailAddressValid) {
            validationErrors.emailAddress.errorMessage = '';
            validationErrors.emailAddress.check = true;
            localStorage.setItem('tovsForm.about.emailAddress', value);
        }
        else {
            validationErrors.emailAddress.errorMessage = this.props.intl.formatMessage({ id: "email.invalid" });
            validationErrors.emailAddress.check = false;
        }
        validationErrors.emailAddress.show = !isEmailAddressValid;
        this.setState({
            emailAddress: value.trim(),
            validationErrors: validationErrors,
            isEmailAddressValid: isEmailAddressValid
        });
    }

    onWebsiteChange(e, ref) {
        let value = ref && ref.newValue ? ref.newValue : e.target.value;
        let validationErrors = this.state.validationErrors;
        let isWebAddressValid = value.trim().match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,18}(:[0-9]{1,5})?(\/.[^\s]+)*$/i) !== null;
        if (isWebAddressValid) {
            validationErrors.webAddress.errorMessage = '';
            validationErrors.webAddress.check = true;
            localStorage.setItem('tovsForm.about.webAddress', value);
        }
        else {
            validationErrors.webAddress.errorMessage = this.props.intl.formatMessage({ id: "web.invalid" });
            validationErrors.webAddress.check = false;
        }
        validationErrors.webAddress.show = !isWebAddressValid;
        this.setState({
            webAddress: value.trim(),
            validationErrors: validationErrors
        });
    }

    // Project Elements
    handleITConsultation(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.itConsultation.check = value !== 'notSure';
        validationErrors.itConsultation.errorMessage = '';
        this.setState({ 
            itConsultation: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.itConsultation', value);
    }

    handleProjectManagement(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.projectManagement.check = value !== 'notSure';
        validationErrors.projectManagement.errorMessage = '';
        this.setState({ 
            projectManagement: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.projectManagement', value);
    }

    handleNewECommerceSite(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.newECommerceSite.check = value !== 'notSure';
        validationErrors.newECommerceSite.errorMessage = '';
        this.setState({ 
            newECommerceSite: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.newECommerceSite', value);
    }

    handleUpgradeECommerceSite(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.upgradeECommerceSite.check = value !== 'notSure';
        validationErrors.upgradeECommerceSite.errorMessage = '';
        this.setState({ 
            upgradeECommerceSite: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.upgradeECommerceSite', value);
    }

    handleCms(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.cms.check = value !== 'notSure';
        validationErrors.cms.errorMessage = '';
        this.setState({ 
            cms: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.cms', value);
    }

    handleOnlinePayments(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.onlinePayments.check = value !== 'notSure';
        validationErrors.onlinePayments.errorMessage = '';
        this.setState({ 
            onlinePayments: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.onlinePayments', value);
    }

    handleBookingSystem(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.bookingSystem.check = value !== 'notSure';
        validationErrors.bookingSystem.errorMessage = '';
        this.setState({ 
            bookingSystem: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.bookingSystem', value);
    }

    handleApp(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.app.check = value !== 'notSure';
        validationErrors.app.errorMessage = '';
        this.setState({ 
            app: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.app', value);
    }

    handleDigitalMarketingDev(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.digitalMarketingDev.check = value !== 'notSure';
        validationErrors.digitalMarketingDev.errorMessage = '';
        this.setState({ 
            digitalMarketingDev: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.digitalMarketingDev', value);
    }

    handleDigitalMarketingImp(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.digitalMarketingImp.check = value !== 'notSure';
        validationErrors.digitalMarketingImp.errorMessage = '';
        this.setState({ 
            digitalMarketingImp: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.digitalMarketingImp', value);
    }

    handleSubscriptionLowCostRetail(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.subscriptionLowCostRetail.check = value !== 'notSure';
        validationErrors.subscriptionLowCostRetail.errorMessage = '';
        this.setState({ 
            subscriptionLowCostRetail: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.subscriptionLowCostRetail', value);
    }

    handleOnlineAds(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.onlineAds.check = value !== 'notSure';
        validationErrors.onlineAds.errorMessage = '';
        this.setState({ 
            onlineAds: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.onlineAds', value);
    }

    handleProPhoto(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.proPhoto.check = value !== 'notSure';
        validationErrors.proPhoto.errorMessage = '';
        this.setState({ 
            proPhoto: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.proPhoto', value);
    }

    handleTraining(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.training.check = value !== 'notSure';
        validationErrors.training.errorMessage = '';
        this.setState({ 
            training: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.training', value);
    }

    handleCopy(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.copy.check = value !== 'notSure';
        validationErrors.copy.errorMessage = '';
        this.setState({ 
            copy: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.copy', value);
    }

    handleSeo(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.seo.check = value !== 'notSure';
        validationErrors.seo.errorMessage = '';
        this.setState({ 
            seo: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.seo', value);
    }

    handleAnalytics(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.analytics.check = value !== 'notSure';
        validationErrors.analytics.errorMessage = '';
        this.setState({ 
            analytics: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.analytics', value);
    }

    handleOther(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.other.check = value !== 'notSure';
        validationErrors.other.errorMessage = '';
        this.setState({ 
            other: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.elements.other', value);
    }

    generateDoc() {
        const data = new CompileTOVS().compile(); 
        var documentCreator = new DocumentCreator();
        var doc = documentCreator.create(data);

        Packer.toBlob(doc).then(function (blob) {
            saveAs(blob, "TradingOnlineVoucherScheme-" + Date.now() + ".docx");
        });
    }

    generateQuote() {
        let validationErrors = this.state.validationErrors;
        this.setState({
            isLoading: true,
            errorMessage: '',
            successMessage: ''
        });
        let url = window.location.search;
        let params = queryString.parse(url);
        const utm = {
            //Identifies which site sent the traffic, and is a required parameter. 
            source: params.utm_source ? params.utm_source : '',
            // Identifies what type of link was used, such as cost per click or email. 
            medium: params.utm_medium ? params.utm_medium : '',
            // Identifies a specific product promotion or strategic campaign.
            campaign: params.utm_campaign ? params.utm_campaign : '',
            // Name of the Ad Group
            group: params.utm_group ? params.utm_group : '',
            // Name of the Ad
            ad: params.utm_ad ? params.utm_ad : '',
            // Identifies search terms.
            term: params.utm_term ? params.utm_term : '',
            // Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link. 
            // It is often used for A/B testing and content-targeted ads.
            content: params.utm_content ? params.utm_content : ''
        };
        let quoteRequest = {
            data: this.state.emailConsent ? new CompileTOVS().compile() : 'no-consent',
            validTOVSQuote: '',
            quoteMessages: [],
            noHostingQuote: 0,
            fiveYearHostingQuote: 0,
            tenYearHostingQuote: 0,
            emailConsent: this.state.emailConsent,
            email: this.state.emailConsent ? this.state.emailAddress : 'no-consent',
            emailConsentText: this.state.emailConsent ? this.props.intl.formatMessage({ id: "i.would.like.a.quote" }) : '',
            gdpr: this.state.emailConsent ? {
                consentDate: Date.now(),
                source: window.location.hostname,
                category: 'prospect',
                purpose: 'marketing',
                grounds: ['consent', 'interests'],
                sensitive: false,
                volume: 10000,
                retention: 31536000000,
                transfer: false,
                transferSafeguards: false
            } : 'no-consent',
            utm: utm
        };
        if (this.state.newECommerceSite === 'yes' || this.state.upgradeECommerceSite === 'yes' || this.state.app === 'yes') {
            if (this.state.newECommerceSite === 'yes' && this.state.upgradeECommerceSite === 'yes' && this.state.app === 'yes') {
                quoteRequest.validTOVSQuote = 'maybe';
                quoteRequest.quoteMessages.push("You have selected Yes to a New eCommerce Website, Upgrade an Existing eCommerce Website and an App! That's a lot for a Trading Online Voucher Scheme. The max amount of €2,500 will likely cover just one of those. If you have never received a voucher before, you are eligible to apply for two €2,500 vouchers. You should work with your supplier to split the work into two projects and deliver the most important one first.");
                quoteRequest.noHostingQuote += 4350;
                quoteRequest.fiveYearHostingQuote += 3300;
                quoteRequest.tenYearHostingQuote += 3850;
            }
            else if (this.state.newECommerceSite === 'yes' && this.state.upgradeECommerceSite === 'yes') {
                quoteRequest.validTOVSQuote = 'maybe';
                quoteRequest.quoteMessages.push("You have selected Yes to a New eCommerce Website and Upgrade an Existing eCommerce Website! That's a lot for a Trading Online Voucher Scheme. The max amount of €2,500 will likely cover just one of those. If you have never received a voucher before, you are eligible to apply for two €2,500 vouchers. You should work with your supplier to split the work into two projects and deliver the most important one first.");
                quoteRequest.noHostingQuote += 1850;
                quoteRequest.fiveYearHostingQuote += 800;
                quoteRequest.tenYearHostingQuote += 1350;
            }
            else if (this.state.upgradeECommerceSite === 'yes' && this.state.app === 'yes') {
                quoteRequest.validTOVSQuote = 'maybe';
                quoteRequest.quoteMessages.push("You have selected Yes to Upgrade an Existing eCommerce Website and an App! That's a lot for a Trading Online Voucher Scheme. The max amount of €2,500 will likely cover just one of those. If you have never received a voucher before, you are eligible to apply for two €2,500 vouchers. You should work with your supplier to split the work into two projects and deliver the most important one first.");
                quoteRequest.noHostingQuote += 3500;
                quoteRequest.fiveYearHostingQuote += 3000;
                quoteRequest.tenYearHostingQuote += 3350;
            }
            else if (this.state.newECommerceSite === 'yes' && this.state.app === 'yes') {
                quoteRequest.validTOVSQuote = 'maybe';
                quoteRequest.quoteMessages.push("You have selected Yes to a New eCommerce Website and an App! That's a lot for a Trading Online Voucher Scheme. The max amount of €2,500 will likely cover just one of those. If you have never received a voucher before, you are eligible to apply for two €2,500 vouchers. You should work with your supplier to split the work into two projects and deliver the most important one first.");
                quoteRequest.noHostingQuote += 3350;
                quoteRequest.fiveYearHostingQuote += 2800;
                quoteRequest.tenYearHostingQuote += 3000;
            }
            if (this.state.newECommerceSite === 'yes') {
                quoteRequest.validTOVSQuote = 'yes';
                quoteRequest.noHostingQuote += 850;
                quoteRequest.fiveYearHostingQuote += 300;
                quoteRequest.tenYearHostingQuote += 500;
            }
            else if (this.state.upgradeECommerceSite === 'yes') {
                quoteRequest.validTOVSQuote = 'yes';
                quoteRequest.noHostingQuote += 1000;
                quoteRequest.fiveYearHostingQuote += 500;
                quoteRequest.tenYearHostingQuote += 850;
            }
            else if (this.state.app === 'yes')   {
                quoteRequest.validTOVSQuote = 'yes';
                quoteRequest.noHostingQuote += 2500;
            }
        }
        else {
            quoteRequest.validTOVSQuote = 'maybe';
            quoteRequest.quoteMessages.push("You will likely need to develop or upgrade an existing website, or in limited cases develop an app, to qualify for the Voucher. You may have a unique idea though, it's always best to verify with your LEO.")
        }
        if (this.state.onlinePayments === 'yes' &&  this.state.bookingSystem === 'yes') {
            quoteRequest.noHostingQuote += 2250;
            quoteRequest.fiveYearHostingQuote += 1750;
            quoteRequest.tenYearHostingQuote += 1750;
        }
        else if (this.state.onlinePayments === 'yes') {
            quoteRequest.noHostingQuote += 1250;
            quoteRequest.fiveYearHostingQuote += 1000;
            quoteRequest.tenYearHostingQuote += 1000;
        }
        else if (this.state.bookingSystem === 'yes') {
            quoteRequest.noHostingQuote += 1000;
            quoteRequest.fiveYearHostingQuote += 750;
            quoteRequest.tenYearHostingQuote += 750;
        }
        else {
            quoteRequest.quoteMessages.push("Unless you already have, you will likely need to implement an online payments or booking system to qualify for the Voucher. You may have a unique idea though, it's always best to verify with your LEO.");
        }
        if (this.state.training === 'yes') {
            quoteRequest.noHostingQuote += 1000;
            quoteRequest.fiveYearHostingQuote += 500;
            quoteRequest.tenYearHostingQuote += 750;
        }
        if (this.state.digitalMarketingDev === 'yes') {
            quoteRequest.noHostingQuote += 1500;
            quoteRequest.fiveYearHostingQuote += 1000;
            quoteRequest.tenYearHostingQuote += 1000;
        }
        if (this.state.digitalMarketingImp === 'yes') {
            quoteRequest.noHostingQuote += 1500;
            quoteRequest.fiveYearHostingQuote += 1000;
            quoteRequest.tenYearHostingQuote += 1000;
        }
        if (this.state.cms === 'yes') {
            quoteRequest.noHostingQuote += 750;
            quoteRequest.fiveYearHostingQuote += 500;
            quoteRequest.tenYearHostingQuote += 500;
        }
        if (this.state.copy === 'yes') {
            quoteRequest.noHostingQuote += 500;
            quoteRequest.fiveYearHostingQuote += 250;
            quoteRequest.tenYearHostingQuote += 250;
        }
        if (this.state.seo === 'yes') {
            quoteRequest.noHostingQuote += 500;
            quoteRequest.fiveYearHostingQuote += 250;
            quoteRequest.tenYearHostingQuote += 250;
        }
        if (this.state.analytics === 'yes') {
            quoteRequest.noHostingQuote += 1000;
            quoteRequest.fiveYearHostingQuote += 500;
            quoteRequest.tenYearHostingQuote += 500;
        }
        if (this.state.onlineAds === 'yes') {
            quoteRequest.noHostingQuote += (quoteRequest.noHostingQuote * 0.25);
            quoteRequest.fiveYearHostingQuote += (quoteRequest.fiveYearHostingQuote * 0.15);
            quoteRequest.tenYearHostingQuote += (quoteRequest.tenYearHostingQuote * 0.15);
        }
        if (this.state.itConsultation === 'yes') {
            quoteRequest.noHostingQuote += (quoteRequest.noHostingQuote * 0.1);
            quoteRequest.fiveYearHostingQuote += (quoteRequest.noHostingQuote * 0.05);
            quoteRequest.tenYearHostingQuote += (quoteRequest.noHostingQuote * 0.05);
        }
        if (this.state.projectManagement === 'yes') {
            quoteRequest.noHostingQuote += (quoteRequest.noHostingQuote * 0.2);
            quoteRequest.fiveYearHostingQuote += (quoteRequest.noHostingQuote * 0.1);
            quoteRequest.tenYearHostingQuote += (quoteRequest.noHostingQuote * 0.1);
        }
        if (!(this.state.isEmailAddressValid)) {
            this.setState({
                errorMessage: 'You need to enter a valid email address to get a quote by email',
                isLoading: false
            });
            return false;
        }
        else if (this.state.emailConsent) {
            validationErrors.emailConsent.check = true;
            if (!this.state.isEmailAddressValid) {
                this.setState({
                    errorMessage: 'You need to enter a valid email address to get a quote by email. Download the file and send it to info@localpro.ie if you prefer.',
                    validationErrors: validationErrors
                
                });
            }
            let success = database.addQuoteRequest(quoteRequest);
             
            if (success) {
                this.setState({
                    errorMessage: '',
                    successMessage: 'Success! Your quote will arrive in the next few days. Email us at info@localpro.ie if your need is more urgent.',
                    isLoading: false
                });
                return true;
            }
            else {
                this.setState({
                    errorMessage: 'Could not create your quote. Email us instead at info@localpro.ie.',
                    isLoading: false
                });
                return false;
            }
        }
        else {
            validationErrors.emailConsent.check = false;
            this.setState({
                validationErrors: validationErrors,
                errorMessage: 'You need to give your consent to get a quote by email',
                isLoading: false
            });
            return false;
        }
    }

    generateViewProps() {
        return {
            ...this.state,
            handleChange: this.handleChange,
            onEmailChange: this.onEmailChange,
            onWebsiteChange: this.onWebsiteChange,
            // Project Elements
            handleITConsultation: this.handleITConsultation,
            handleProjectManagement: this.handleProjectManagement,
            handleNewECommerceSite: this.handleNewECommerceSite,
            handleUpgradeECommerceSite: this.handleUpgradeECommerceSite,
            handleCms: this.handleCms,
            handleOnlinePayments: this.handleOnlinePayments,
            handleBookingSystem: this.handleBookingSystem,
            handleApp: this.handleApp,
            handleDigitalMarketingDev: this.handleDigitalMarketingDev,
            handleDigitalMarketingImp: this.handleDigitalMarketingImp,
            handleSubscriptionLowCostRetail: this.handleSubscriptionLowCostRetail,
            handleOnlineAds: this.handleOnlineAds,
            handleProPhoto: this.handleProPhoto,
            handleTraining: this.handleTraining,
            handleCopy: this.handleCopy,
            handleSeo: this.handleSeo,
            handleAnalytics: this.handleAnalytics,
            handleOther: this.handleOther,
            generateDoc: this.generateDoc,
            generateQuote: this.generateQuote
        };
    }

    render() {
        const viewProps = this.generateViewProps();
        return (
            <ProjectElementsView {...viewProps} />
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLocale: locale => dispatch(setLocale(locale))
    };
};

const ProjectElementsContainer = injectIntl(connect(mapStateToProps,mapDispatchToProps)(ConnectedProjectElementsContainer));

export default ProjectElementsContainer;